'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import {Row, Col} from 'react-flexbox-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _BenchmarkGrid = require('./BenchmarkGrid.css');

var _BenchmarkGrid2 = _interopRequireDefault(_BenchmarkGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BenchmarkGrid = (_dec = (0, _reactCssModules2.default)(_BenchmarkGrid2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(BenchmarkGrid, _Component);

  function BenchmarkGrid() {
    (0, _classCallCheck3.default)(this, BenchmarkGrid);
    return (0, _possibleConstructorReturn3.default)(this, (BenchmarkGrid.__proto__ || (0, _getPrototypeOf2.default)(BenchmarkGrid)).apply(this, arguments));
  }

  (0, _createClass3.default)(BenchmarkGrid, [{
    key: 'render',
    value: function render() {
      var gradeField = null;
      var gradeName = null;
      switch (_config2.default.app.title) {
        case 'Fossil Free Funds':
          gradeField = 'grade_fossil';
          gradeName = 'fossil fuel';
          break;
        case 'Deforestation Free Funds':
          gradeField = 'grade_deforestation';
          gradeName = 'deforestation';
          break;
        case 'Weapon Free Funds':
          gradeField = 'grade_military';
          gradeName = 'military weapons';
          break;
        case 'Gun Free Funds':
          gradeField = 'grade_guns';
          gradeName = 'civilian firearms';
          break;
        case 'Tobacco Free Funds':
          gradeField = 'grade_tobacco';
          gradeName = 'tobacco';
          break;
        case 'Gender Equality Funds':
          gradeField = 'grade_gender_equality';
          gradeName = 'gender equality';
          break;
        case 'Prison Free Funds':
          gradeField = 'grade_prison_industrial_complex';
          gradeName = 'prison industrial complex';
          break;
        default:
          break;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'benchmark-grid-wrap' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'companies' }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'companies-title' },
              'Index funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'companies-info' },
              'Passively managed investment funds that track market indexes have seen significant fund inflows over the past decade. These indexes, from firms like from S&P Global Ratings, Russell/FTSE, and MSCI, are increasingly setting our economy on autopilot and pumping capital into unsustainable business models. Below are the ',
              gradeName,
              ' grades for 10 common index funds.'
            )
          ),
          _react2.default.createElement(_components.BenchmarkGridTable, { gradeField: gradeField, gradeName: gradeName }),
          _react2.default.createElement(
            'div',
            { styleName: 'companies-more-link' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.clean,
                title: 'Search funds | ' + _config2.default.app.title,
                roundbutton: true
              },
              'More funds',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return BenchmarkGrid;
}(_react.Component)) || _class);
exports.default = BenchmarkGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/BenchmarkGrid/BenchmarkGrid.js
// module id = 1349
// module chunks = 0